<script setup>
import { ref } from "vue";

const items = [
    { name: "Sole Proprietorship", value: "sole-proprietorship" },
    { name: "Partnership", value: "partnership" },
    { name: "Incorporation", value: "incorporation" },
    { name: "Registered", value: "registered" },
];
const selected = ref({});
const props = defineProps({ filter: Object });
const emit = defineEmits(["apply"]);

const handleSelect = (selection) => {
    selected.value = selection;
    emit("apply", Object.assign(props.filter, { value: selection }));
};
</script>
<template>
    <div class="origin-top-left min-h-56 absolute left-0 mt-2 top-[28px] bg-white px-[20px] py-[12px] rounded-lg w-[300px]">
        <label for="location" class="block text-sm font-medium text-gray-700"
            >Business Type</label
        >
        <select
            id="location"
            @change="handleSelect($event.target.value)"
            name="location"
            class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
        >
            <option v-for="item in items" :key="item.value" :value="item.value">
                {{ item.name }}
            </option>
        </select>
    </div>
</template>
